import { render, staticRenderFns } from "./StepCreate.vue?vue&type=template&id=5563e3d1&scoped=true"
import script from "./StepCreate.vue?vue&type=script&lang=js"
export * from "./StepCreate.vue?vue&type=script&lang=js"
import style0 from "./StepCreate.vue?vue&type=style&index=0&id=5563e3d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5563e3d1",
  null
  
)

export default component.exports